import { useCallback, useEffect, useMemo, useState } from 'react';
import { CommandPickerItem } from 'components/organisms/document-editor/extensions/command-picker/types';
import { useDefaultBlockCommandsForPeoplePageTemplate } from './default-commands';

export const useCommandsForPeoplePageTemplatePicker = () => {
  const defaultBlockCommands = useDefaultBlockCommandsForPeoplePageTemplate();

  return useMemo(
    () => ({
      items: [...defaultBlockCommands],
      isLoading: false,
    }),
    [defaultBlockCommands],
  );
};
export const useCommandsForPeoplePageTemplatePickerAsPromise = () => {
  const [resolveFunction, setResolveFunction] = useState<
    ((items: CommandPickerItem[]) => void) | null
  >(null);
  const commandsForCommandPicker = useCommandsForPeoplePageTemplatePicker();

  useEffect(() => {
    if (!commandsForCommandPicker.isLoading && resolveFunction) {
      resolveFunction(commandsForCommandPicker.items || []);
      setResolveFunction(null);
    }
  }, [commandsForCommandPicker, resolveFunction]);

  return useCallback(() => {
    return new Promise<CommandPickerItem[]>((resolve) => {
      if (!commandsForCommandPicker.isLoading) {
        resolve(commandsForCommandPicker.items || []);
      } else {
        setResolveFunction(() => resolve);
      }
    });
  }, [commandsForCommandPicker, setResolveFunction]);
};
